/**
 * Keyboard Focus Detection
 * 
 * Adds a class to the body when the user is navigating with keyboard,
 * allowing focus outlines to be visible for keyboard users but hidden for mouse users.
 */

let keyboardUsed = false;

// Listen for Tab key press
function handleKeyDown(e) {
    if (e.key === 'Tab') {
        keyboardUsed = true;
        document.body.classList.add('user-is-tabbing');
    }
}

// Listen for mouse click
function handleMouseDown() {
    keyboardUsed = false;
    document.body.classList.remove('user-is-tabbing');
}

// Initialize
document.addEventListener('keydown', handleKeyDown);
document.addEventListener('mousedown', handleMouseDown);

// Also detect initial focus if it's already keyboard-based
document.addEventListener('focus', (e) => {
    if (keyboardUsed) {
        document.body.classList.add('user-is-tabbing');
    }
}, true);
